import React from 'react';
import Header from 'components/Header';
import Portal from './Portal';
import './studentportal.less';
import moduleConfig from './moduleConfig';
import AppContext from 'components/appContext';

const moduleCode = "STUDENT_PORTAL_MODULE";
const sceneCode = "STUDENT_PORTAL";
export default class StudentPortal extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        this.context.registerModule(moduleCode, moduleConfig.map);
        this.context.setCurrentModule(moduleCode);
        this.context.setCurrentScene(sceneCode);
    }

    render() {
        return (
            <div className="studentPortal-scene full-height--with-policy flex-column row">
                <Header {...this.props} showBackButton={false}/>
                
                <Portal/>
            </div>
        )
    }
}
